import { generate, type ToVariants } from '@/components/experiments/Core/generateBasicExperimentComponent';

// ?preferred_variant=BUYBOX_EXP_3:control
// ?preferred_variant=BUYBOX_EXP_3:variant_1
// ?preferred_variant=BUYBOX_EXP_3:variant_2

export const BuyboxExp3Name = 'BUYBOX_EXP_3' as const;

export type BuyboxExp3Variants = ToVariants<typeof BuyboxExp3Variants>;

export const BuyboxExp3Variants = {
	/** Current BuyBox */
	CONTROL: 'control',
	/** Last V2 (winner) with filter below promoted buybox */
	VARIANT_1: 'variant_1',
	/** Free trial additions/changes */
	VARIANT_2: 'variant_2',
} as const;

export default generate(BuyboxExp3Name, BuyboxExp3Variants);
